export const ORGANIZATION_BASE_URL = window.location.origin;
export const LOGIN_ROUTE = "/login";
